module.exports = __webpack_public_path__ + "img/kjsy_gallery9.5c265495.jpg";